// HEADER VIDEO HIDDEN AFTER PLAY
// FADE-IN-UP ELEMENTS ON SCROLL
// FLIP CARD
// SLIDER (SWIPER JS)
// VIDEO POP-UP

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------
initVideoGrid();

const vid = document.getElementById("msdw-video-responsive");

function changeVideoSize(size) {
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-" + size));
  vid.autoplay = true;
  vid.load();
  console.log(videoSource.attr("src"));
}

function loadVideo() {
  var sm = window.matchMedia("(min-width: 0px) and (max-width: 599px)"), // Standard def (mp4, 640x360)
    md = window.matchMedia("(min-width: 600px) and (max-width: 899px)"), // Standard def (mp4, 960x540)
    lg = window.matchMedia("(min-width: 900px) and (max-width: 1199px)"), // High def (mp4, 1280x720)
    xl = window.matchMedia("(min-width: 1200px) and (max-width: 99999px)"); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if (sm.matches) {
    changeVideoSize("sm");
  } else if (md.matches) {
    changeVideoSize("md");
  } else if (lg.matches) {
    changeVideoSize("lg");
  } else if (xl.matches) {
    changeVideoSize("xl");
  }
}

if (document.contains(vid)) {
  document.addEventListener("DOMContentLoaded", loadVideo);
  vid.onloadeddata = () => vid.classList.add("msdw-video-loaded");
  window.onresize = loadVideo;
}

//
// =HEADER VIDEO HIDDEN AFTER PLAY
// --------------------------------------------------

// const videos = document.querySelectorAll(".msdw-header-video");

// videos.forEach((video) => {
//   video.onended = function () {
//     video.style.opacity = 0;
//   };
// });

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));

//
// =FLIP CARD
// --------------------------------------------------

const cards = document.querySelectorAll(".msdw-flip-card");
const togglers = document.querySelectorAll(".msdw-icon--plus");

togglers.forEach((toggler) => {
  toggler.addEventListener("click", () =>
    toggler.closest(".msdw-flip-card").classList.toggle("is-flipped")
  );
});

//
// =SLIDERS (SWIPER JS)
// --------------------------------------------------

const sliderParticipants = new Swiper("#sliderParticipants", {
  slidesPerView: 1,
  loop: false,
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: { crossFade: true },
  speed: 500,
  navigation: {
    nextEl: ".swiper-participants-button-next",
    prevEl: ".swiper-participants-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  autoHeight: true,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
});

sliderParticipants.on("slideChange", function () {
  cards.forEach((card) => {
    card.classList.remove("is-flipped");
  });
});

sliderParticipants.on("slideChange", function () {
  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: $("#sliderParticipants").parent().offset().top - 59,
    },
    350
  );
});

const slidersPrecamp = document.querySelectorAll('.swiper-precamp');

slidersPrecamp.forEach((el, i) => {
  el.classList.add('swiper-precamp-' + i);

  let slider = new Swiper('.swiper-precamp-' + i, {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    speed: 500,
    navigation: {
      nextEl: ".swiper-precamp-button-next",
      prevEl: ".swiper-precamp-button-prev",
    },
    pagination: {
      el: ".swiper-precamp-pagination",
      type: "fraction",
    },
    breakpoints: {
      600: {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 15,
        initialSlide: 0,
      },
      900: {
        centeredSlides: true,
        slidesPerView: 1.975,
        spaceBetween: 20,
        initialSlide: 0,
      },
    }
  });
});



const slidersJourney = document.querySelectorAll('.swiper-journey');

slidersJourney.forEach((el, i) => {
  el.classList.add('swiper-journey-' + i);

  let slider = new Swiper('.swiper-journey-' + i, {
    speed: 500,
    grabCursor: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: [0, 0, -400],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    navigation: {
      nextEl: ".swiper-journey-button-next",
      prevEl: ".swiper-journey-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  });
});

const sliderProducts = new Swiper("#sliderProducts", {
  slidesPerView: 1,
  slidesPerGroup: 1, // you need this
  loop: false,
  freeMode: {
    enabled: true,
    sticky: true,
  },
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-products-button-next",
    prevEl: ".swiper-products-button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      slidesPerGroup: 2, // you need this
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      slidesPerGroup: 3, // you need this
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4, // you need this
      spaceBetween: 20,
    },
  },
});

//
// =VIDEO POP-UP
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");

if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.getAttribute("data-modal-video");
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });

  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;

    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };

  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });

  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}

//
// =SUB PAGE: ZOOM IN HEADER
// --------------------------------------------------

// Higher number = more zoom
let scaleAmount = 0.5;

function scrollZoom() {
  const images = document.querySelectorAll("[data-scroll-zoom]");
  let scrollPosY = 0;
  scaleAmount = scaleAmount / 100;

  const observerConfig = {
    rootMargin: "0% 0% 0% 0%",
    threshold: 0,
  };

  // Create separate IntersectionObservers and scroll event listeners for each image so that we can individually apply the scale only if the image is visible
  if (images) {
    images.forEach((image) => {
      let isVisible = false;
      const observer = new IntersectionObserver((elements, self) => {
        elements.forEach((element) => {
          isVisible = element.isIntersecting;
        });
      }, observerConfig);

      observer.observe(image);

      // Set initial image scale on page load
      image.style.transform = `scale(${
        1 + scaleAmount * percentageSeen(image)
      })`;

      // Only fires if IntersectionObserver is intersecting
      window.addEventListener("scroll", () => {
        if (isVisible) {
          scrollPosY = window.pageYOffset;
          image.style.transform = `scale(${
            1 + scaleAmount * percentageSeen(image)
          })`;
        }
      });
    });
  }

  // Calculates the "percentage seen" based on when the image first enters the screen until the moment it leaves
  // Here, we get the parent node position/height instead of the image since it's in a container that has a border, but
  // if your container has no extra height, you can simply get the image position/height
  function percentageSeen(element) {
    const parent = element.parentNode;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const elPosY = parent.getBoundingClientRect().top + scrollY;
    const borderHeight =
      parseFloat(
        getComputedStyle(parent).getPropertyValue("border-bottom-width")
      ) +
      parseFloat(
        getComputedStyle(element).getPropertyValue("border-top-width")
      );
    const elHeight = parent.offsetHeight + borderHeight;

    if (elPosY > scrollY + viewportHeight) {
      // If we haven't reached the image yet
      return 0;
    } else if (elPosY + elHeight < scrollY) {
      // If we've completely scrolled past the image
      return 100;
    } else {
      // When the image is in the viewport
      const distance = scrollY + viewportHeight - elPosY;
      let percentage = distance / ((viewportHeight + elHeight) / 100);
      percentage = Math.round(percentage);

      return percentage;
    }
  }
}

scrollZoom();

//
// =SUB PAGE: NO VIDEO AUTOPLAY
// --------------------------------------------------

const subVideo = document.querySelector(
  ".msdw-sub-page #msdw-video-responsive"
);

window.addEventListener("DOMContentLoaded", () => {
  if (subVideo) {
    subVideo.autoplay = false;
  }
});


//
// =RENDER YT PLAYLIST VIDEOS IN A GRID
// --------------------------------------------------
function initVideoGrid() {
  var key = 'AIzaSyDqIn7hpzFnbDAkGAyzoFX6ETJ45yC6Q9I';
  var playlistIdValue = $('#msdw-video-grid').data("playlist");
  var playlistId = playlistIdValue;
  var URL = 'https://www.googleapis.com/youtube/v3/playlistItems';
  var options = {
      part: 'snippet',
      key: key,
      maxResults: 10,
      playlistId: playlistId
  }
  loadVids();
  function loadVids() {
      $.getJSON(URL, options, function (data) {
          // var id = data.items[0].snippet.resourceId.videoId;
          // console.log(data);
          $.each(data.items, function (i, item) {
              var vid = item.snippet.resourceId.videoId;
              $('#msdw-yt-videos').append(`
                  <a href="https://www.youtube.com/watch?v=${vid}?rel=0&amp;&showinfo=0&cc_load_policy=11&cc_lang_pref=en" id="msdw-yt-${i}" data-youtube-id="${vid}" class="js-trigger-video-modal jws-displayBlock"></a>
              `);
              // $('#msdw-yt-videos').append('<a href="https://www.youtube.com/watch?v='+vid+'" id="msdw-yt-'+i+'" data-youtube-id="'+vid+'" class="js-trigger-video-modal jws-displayBlock"></a>');
          });
          moveVids();
          // INIT VIDEO MODAL
          toggle_video_modal();
      });
  }
  function moveVids() {
      if ('#msdw-yt-0') { $('#msdw-video-01 figure img').wrap( $('#msdw-yt-0') ) }
      if ('#msdw-yt-1') { $('#msdw-video-02 figure img').wrap( $('#msdw-yt-1') ) }
      if ('#msdw-yt-2') { $('#msdw-video-03 figure img').wrap( $('#msdw-yt-2') ) }
      if ('#msdw-yt-3') { $('#msdw-video-04 figure img').wrap( $('#msdw-yt-3') ) }
      if ('#msdw-yt-4') { $('#msdw-video-05 figure img').wrap( $('#msdw-yt-4') ) }
      if ('#msdw-yt-5') { $('#msdw-video-06 figure img').wrap( $('#msdw-yt-5') ) }
      if ('#msdw-yt-6') { $('#msdw-video-07 figure img').wrap( $('#msdw-yt-6') ) }
      if ('#msdw-yt-7') { $('#msdw-video-08 figure img').wrap( $('#msdw-yt-7') ) }
      if ('#msdw-yt-8') { $('#msdw-video-09 figure img').wrap( $('#msdw-yt-8') ) }
      if ('#msdw-yt-9') { $('#msdw-video-10 figure img').wrap( $('#msdw-yt-9') ) }
  }
}
//
// =YT VIDEO MODAL
// --------------------------------------------------
function toggle_video_modal() {
  $(".js-trigger-video-modal").on("click", function(e){
      e.preventDefault();
      var id = $(this).attr('data-youtube-id');
      var autoplay = '?autoplay=1';
      var related_no = '&rel=0';
      var src = '//www.youtube.com/embed/'+id+autoplay+related_no;
      $("#youtube").attr('src', src);
      $("body").addClass("show-video-modal noscroll");
  });
  function close_video_modal() {
      $("body").removeClass("show-video-modal noscroll");
      $("#youtube").attr('src', '');
  }
  $('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {
      close_video_modal();
  });
  $('body').keyup(function(e) {
      if (e.keyCode == 27) {
          close_video_modal();
      }
  });
}